import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Form, Row, Col, Select, Input, Radio, DatePicker } from 'antd';
import { SimpleNumericInput } from 'components';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { TIPO_MONITOREOS } from 'constants/nombresCatalogos';
import { DATE_FORMAT_FILTER_COLUMN } from 'utils/date';
import { searchAtributos } from 'constants/searchAtributos';
import * as fieldMsgs from 'constants/formFieldsMessages';

const DatosHallazgo = ({ form, catNombreMedImp, setCatNombreMedImp }) => {
  const [cuentaLeyenda, setCuentaLeyenda] = useState(null);
  const [tipoMedioImpOtro, setTipoMedioImpOtro] = useState(false);
  const [subtipoMedioImpOtro, setsubtipoMedioImpOtro] = useState(false);
  const tipoMonitoreosData = useSelector(selectCatalogByName(TIPO_MONITOREOS));
  const [selectedAtributos, setSelectedAtributos] = useState([]); // Lista de atributos para renderizarlos
  // Catálogo para campo "Tipo de medio impreso"
  let catTipoMedioImp = null;
  for (let i = 0; i < tipoMonitoreosData.length; i += 1) {
    if (tipoMonitoreosData[i].idTipoMonitoreo === 2) {
      // tipoHallazgos
      catTipoMedioImp = tipoMonitoreosData[i].tipoHallazgos;
    }
  }
  const handleTipoMedioImpreso = (value) => {
    const tipoMedioSeleccionado = catTipoMedioImp.find((tipo) => tipo.idHallazgo === value);
    setSelectedAtributos(searchAtributos(tipoMedioSeleccionado?.atributos));
    setTipoMedioImpOtro(tipoMedioSeleccionado?.nombreHallazgo.includes('Otro'));
    form.setFieldValue('idSubTipoHallazgo', null);
    if (tipoMedioSeleccionado?.idHallazgo !== 0) {
      setCatNombreMedImp(tipoMedioSeleccionado?.subTipoHallazgos);
      setsubtipoMedioImpOtro(false);
      form.setFieldValue('otroSubTipoHallazgo', null);
      return false;
    }
    setCatNombreMedImp([]);
    return false;
  };

  const handleNombreMedImp = (value) => {
    if (value === 0) {
      return setsubtipoMedioImpOtro(true);
    }
    return setsubtipoMedioImpOtro(false);
  };

  const onChangeCuentaLeyenda = (e) => {
    setCuentaLeyenda(e.target.value);
  };

  const handletipoMedida = (value) => {
    tipoMonitoreosData[1].tiposMedida.forEach((x) => {
      if (x.idTipoMedida === value) {
        form.setFieldsValue({
          medidaN: x.medida
        });
      }
    });
  };

  return (
    <div className="div-datosg">
      <Form form={form} layout="vertical">
        <Row gutter={[12, 12]}>
          <Col span={5}>
            <Form.Item
              name="idTipoHallazgo"
              label="Tipo de medio impreso:"
              rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
              <Select
                placeholder="Selecciona"
                onChange={handleTipoMedioImpreso}
                fieldNames={{
                  value: 'idHallazgo',
                  label: 'nombreHallazgo'
                }}
                options={catTipoMedioImp}
                filterOption={(inputValue, option) =>
                  option.nombreHallazgo?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
                showSearch
              />
            </Form.Item>
            {tipoMedioImpOtro ? (
              <Form.Item name="otroTipoHallazgo" label="">
                <Input placeholder="Especifica " />
              </Form.Item>
            ) : null}
          </Col>

          {selectedAtributos?.includes('Nombre') && (
            <Col span={4}>
              <Form.Item
                name="idSubTipoHallazgo" // nombreTipoHallazgoMedImp
                label="Nombre:"
                rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                <Select
                  placeholder="Selecciona"
                  onChange={handleNombreMedImp}
                  fieldNames={{
                    value: 'idTipoHallazgo',
                    label: 'nombreTipoHallazgo'
                  }}
                  options={catNombreMedImp}
                  filterOption={(inputValue, option) =>
                    option.nombreTipoHallazgo?.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                    -1
                  }
                  showSearch
                />
              </Form.Item>
              {subtipoMedioImpOtro ? (
                <Form.Item
                  name="otroSubTipoHallazgo"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Especifica..." />
                </Form.Item>
              ) : null}
            </Col>
          )}
          {selectedAtributos?.includes('Grupo editorial') && (
            <Col span={4}>
              <Form.Item
                name="grupoEditorial"
                label="Grupo editorial:"
                rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                <Input placeholder="Escribe..." maxLength={20} />
              </Form.Item>
            </Col>
          )}
          {selectedAtributos?.includes('Sección') && (
            <Col span={4}>
              <Form.Item
                name="seccion"
                label="Sección:"
                rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                <Input placeholder="Escribe..." maxLength={20} />
              </Form.Item>
            </Col>
          )}
          {selectedAtributos?.includes('Página') && (
            <Col span={3}>
              <Form.Item
                name="pagina"
                label="Página:"
                rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                <SimpleNumericInput placeholder="No. de página" maxLength={10} />
              </Form.Item>
            </Col>
          )}
          {selectedAtributos?.includes('Cantidad') && (
            <Col span={3}>
              <Form.Item name="cantidad" label="Cantidad:">
                <SimpleNumericInput placeholder="Escribe..." />
              </Form.Item>
            </Col>
          )}
          {selectedAtributos?.includes('Fecha de publicación') && (
            <Col span={5}>
              <Form.Item
                name="fechaPublicacion"
                label="Fecha de publicación:"
                rules={[{ required: true, message: fieldMsgs.ERR_DATE_FIELD_REQUIRED }]}>
                <DatePicker
                  placeholder="Selecciona..."
                  style={{ width: '100%' }}
                  format={DATE_FORMAT_FILTER_COLUMN}
                />
              </Form.Item>
            </Col>
          )}
          {selectedAtributos?.includes('Tipo de medida') && (
            <Col span={4}>
              <Form.Item
                name="idTipoMedida"
                label="Tipo de medida:"
                rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                <Select
                  placeholder="Selecciona"
                  onChange={handletipoMedida}
                  fieldNames={{
                    value: 'idTipoMedida',
                    label: 'tipoMedida'
                  }}
                  options={tipoMonitoreosData[1].tiposMedida}
                  filterOption={(inputValue, option) =>
                    option.tipoMedida?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                  }
                  showSearch
                />
              </Form.Item>
            </Col>
          )}
          {selectedAtributos?.includes('Tipo de medida') && (
            <Col span={4}>
              <Form.Item name="medidaN" label="Medida:">
                <Input disabled />
              </Form.Item>
            </Col>
          )}
          {selectedAtributos?.includes('Leyenda de inserción pagada') && (
            <Col span={8}>
              <Form.Item
                name="leyendaPagada"
                label="¿Cuenta con leyenda de inserción pagada?"
                rules={[{ required: true, message: fieldMsgs.ERR_RADIO_FIELD_REQUIRED }]}>
                <Radio.Group className="radio-datosh radio-style" onChange={onChangeCuentaLeyenda}>
                  <Radio value={1}>Sí</Radio>
                  <Radio value={0}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          )}
          <Col span={2} />
          {cuentaLeyenda === 1 && selectedAtributos?.includes('Leyenda de inserción pagada') ? (
            <Col span={8}>
              <Form.Item
                name="responsablePago"
                label="Responsable del pago:"
                rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                <Input placeholder="Escribe..." maxLength={200} />
              </Form.Item>
            </Col>
          ) : null}
        </Row>
      </Form>
    </div>
  );
};

DatosHallazgo.propTypes = {
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
    setFieldsValue: PropTypes.func
  }).isRequired,
  catNombreMedImp: PropTypes.shape({}).isRequired,
  setCatNombreMedImp: PropTypes.func.isRequired
};

export default DatosHallazgo;
